import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import FormControl from "@mui/material/FormControl";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { Inactive, Unmaped, Active } from "../../shared/ActivaInactive";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const WathsAppConfiguration = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = React.useState(false);
  const storeId = localStorage.getItem("store_id");
  const [url, setUrl] = useState("");
  const [message, setMessage] = useState("");
  const [instance, setInstace] = useState("");
  const [access, setAccess] = useState("");
  const [active, setActive] = useState("");
  const [ids, setIds] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const whatsappDataList = () => {
    axiosInstance
      .get(`api/admin/whatsapp-configuration-store/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        console.log(
          "whatsapp Data list===>",
          response?.data?.settingwhatsappconfiguration,
        );
        setData(response?.data?.settingwhatsappconfiguration);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    whatsappDataList();
  }, []);

  // const storeList = () => {
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/multivendor-show-store-list/`,
  //       {
  //         page: 1,
  //         search_values: "",
  //       },
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setStoreData(response?.data?.data);
  //       console.log("store data list==>", response?.data?.data);
  //     })
  //     .catch((error) => {
  //       console.log("", error.response);
  //       console.log(error);
  //       toast.error(error.message);
  //     });
  // };

  // useEffect(() => {
  //   storeList();
  // }, []);

  const hangleCancel = () => {
    setIds(null);
    setMessage("");
    setInstace("");
    setAccess("");
    setActive("");
    setUrl("");
    handleClose();
  };

  const submitCategory = () => {
    const fd = new FormData();
    fd.append("url", url);
    fd.append("message_type", message);
    fd.append("instance_id", instance);
    fd.append("access_token", access);
    fd.append("active_status", active);
    axiosInstance
      .post(`api/admin/whatsapp-configuration-store/?store_id=${storeId}`, fd, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        toast.success(response?.data?.message);
        setUrl();
        setMessage();
        setInstace();
        setAccess();
        setActive();
        whatsappDataList();
        handleClose();
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };
  const editFunctionality = (event, row) => {
    event.preventDefault();
    handleOpen();
    setIds(row?.id);
    setUrl(row?.url);
    setMessage(row?.message_type);
    setInstace(row?.instance_id);
    setAccess(row?.access_token);
    setActive(row?.active_status ? "True" : "False");
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            WhatsApp Configuration
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleOpen}
          >
            <AddIcon />
            Add Email
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box
              sx={{ ...style, width: 850 }}
              className="rounded-2xl !border-0"
            >
              <div
                id="child-modal-title "
                className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
              >
                {ids === null ? "Add WhatsApp" : "Update WhatsApp"}
              </div>

              <div className="flex justify-between">
                <div className="w-[48%]">
                  <div className="">URL : </div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    name="product_name"
                    value={url}
                    onChange={(event) => setUrl(event.target.value)}
                  />
                  <div className="mt-2">Access Token : </div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    name="product_name"
                    value={access}
                    onChange={(event) => setAccess(event.target.value)}
                  />
                  <div className="mt-3">
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        <span className="text-gray-700"> Active Status :</span>
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={"" || active}
                        onChange={(event) => setActive(event.target.value)}
                      >
                        <FormControlLabel
                          value="True"
                          control={<Radio />}
                          label="True"
                        />
                        <FormControlLabel
                          value="False"
                          control={<Radio />}
                          label="False"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="w-[48%]">
                  <div className="">Instance : </div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    value={instance}
                    onChange={(event) => setInstace(event.target.value)}
                  />
                  <div className="mt-2">Message : </div>
                  <TextField
                    size="small"
                    id="outlined-basic"
                    className="!w-[100%] !mt-1"
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                </div>
              </div>
              <Button
                onClick={hangleCancel}
                variant="contained"
                color="warning"
                className="!py-2 !mt-3"
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                type="submit"
                color="success"
                className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                onClick={submitCategory}
              >
                {ids === null ? "ADD" : "UPDATE"}
              </Button>
            </Box>
          </Modal>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex justify-between my-3">
          <span className="flex  gap-3"></span>
          <span>
            <div className="text-red-500 mx-3">
              {/* <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Store
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select Store"
                  className="w-72"
                  size="small"
                  onChange={(event) => setFindStoreID(event.target.value)}
                >
                  {storeData?.map((item) => (
                    <MenuItem value={item?.id}>{item?.store_name}</MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-24">STORE NAME</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  INSTANCE ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-36">ACCESS TOKEN </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">MESSAGE TYPE </div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">URL</div>
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  <div className="w-40">Active Status</div>
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              <TableRow className="!text-slate-700">
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data.id ? data.id : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.store?.store_name ? data?.store?.store_name : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.instance_id ? data?.instance_id : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.access_token ? data?.access_token : "--"}
                </TableCell>

                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.message_type ? data?.message_type : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {data?.url ? data?.url : "--"}
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {" "}
                  <div className="flex justify-center w-full p-4">
                    {data?.active_status === null ? (
                      <Unmaped />
                    ) : data.active_status === true ? (
                      <Active />
                    ) : (
                      <Inactive />
                    )}
                  </div>
                </TableCell>
                <TableCell
                  className="!text-center !text-[12px]"
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  <BorderColorIcon
                    className="text-green-500"
                    onClick={(event) => editFunctionality(event, data)}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WathsAppConfiguration;
